import { Component, OnInit, AfterContentInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from "../../../base/base-component.component";
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from "../../../services/general/auth/authentication.service";

@Component({
  selector: 'side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent extends BaseComponent implements OnInit, AfterContentInit {

  siteName: string;
  username: string;

  @Input()
  isPages: boolean = false;

  constructor(
    private readonly authenticationService: AuthenticationService,
    translateService: TranslateService,
    private readonly route: ActivatedRoute) {
    super(translateService);
    this.setTranslateContext('SideBarComponent');
  }

  ngOnInit() {
    this.setUserInfos();
  }

  ngAfterContentInit(): void {

  }

  setUserInfos(): void {
    const sub = this.authenticationService
      .getCurrentUser()
      .subscribe(v => {
        if (!v) return;
        if (v.data.fullname) {
          this.username = v.data.fullname.iv;
        } else {
          this.username = v.data.email.iv;
        }
      });
    this.subscriptions.push(sub);
  }
}
